module.exports = "/static/assets/0048354f2d2f5a137359716b07da6ddd.png";